import React, {useEffect, useRef, useState} from "react";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {useHistory} from "react-router-dom";
import {
    ACTION_TEXT,
    ACTIVITY_TITLE_TEXT,
    CODE_TEXT,
    ACTIVITY_LINK_TEXT,
    LIVE_ACTIVITIES_DESCRIPTION,
    LIVE_ACTIVITIES_TEXT,
    POLL_STATUS_HEADER,
    SHARED_ENTIRELY,
    TEXTBOX,
    VIEW_ACTIVITIES_TEXT, COPY_LINK_TEXT, COPIED_TEXT,
} from "../../utils/constants";
import {getPollStatus, removePrefixNew} from "../../utils/helpers";
import styles from "./DashboardPage.module.css";
import {ReactComponent as Copy} from "./images/gradient_copy_icon.svg";
import {ReactComponent as ActivePollIcon} from "./images/gradient_radar_icon.svg";
import {Table} from "react-bootstrap";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {useConfig} from "../../hooks/useConfig";

export default function DashboardCardLiveActivities({data = [], loading = true}) {
    const history = useHistory();
    const config = useConfig();
    const panelBodyRef = useRef();
    const [copied, setCopied] = useState("");

    const hostname = window.location.hostname;
    let shortName = '';
    if (hostname.includes(config.host_url) && hostname.includes("www")) {
        shortName = hostname.indexOf('.') >= 0 ?
            hostname.substring(hostname.indexOf('.') + 1, hostname.indexOf("engage.yuja.com") - 1) :
            hostname;
    } else {
        shortName = hostname.indexOf('.') >= 0 ?
            hostname.substring(0, hostname.indexOf('.')) :
            hostname;
    }


    const viewResult = (poll) => {
        const {pk, index3Pk} = poll;
        history.push({
            pathname: `/poll/share/${removePrefixNew(pk)}/${removePrefixNew(index3Pk)}`,
            // state: { expandedAnalytics: true }
        });
    }

    useEffect(() => {

        let timeOutId = setTimeout(() => {
            setCopied("");
        }, 3000);


        return () => {
            if (timeOutId) {
                clearTimeout(timeOutId);
            }
        }

    }, [copied]);

    if (loading) {
        return (
            <div style={{height: 250, width: "100%"}}>
                <Skeleton borderRadius={10} height={"100%"} width={"100%"}/>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return <></>;
    }

    return (
        <div className={`${styles.panelContainer} ${styles.topCard}`} style={{display: "flex", flexDirection: "column"}}>
            <div className={styles.panelTitle}>
                <ActivePollIcon style={{marginRight: "15px", flexShrink: 0, width: 18, height: 18}}/>
                <div role={TEXTBOX} >{LIVE_ACTIVITIES_TEXT}</div>
            </div>
            <div className={styles.panelBody} ref={panelBodyRef}>
                {/* <Spin size="large" wrapperClassName="panelSpin" spinning={loading} tip="Loading..." style={{height: "100%"}}> */}
                <div role={TEXTBOX} className={styles.panelDescription} style={{alignSelf: "start"}}>
                    {LIVE_ACTIVITIES_DESCRIPTION}
                </div>

                <div className={styles.tableWrapper}>
                    <Table className={styles.recentResultTable} hover>
                        <thead>
                        <tr>
                            <th role={TEXTBOX} style={{width: 200, minWidth: 0, textAlign: "left"}}>{ACTIVITY_TITLE_TEXT}</th>
                            <th role={TEXTBOX} style={{width: 120, minWidth: 0}}>{CODE_TEXT}</th>
                            <th role={TEXTBOX} style={{width: 180, minWidth: 0}}>{POLL_STATUS_HEADER}</th>
                            <th role={TEXTBOX} style={{width: 120, minWidth: 0,}}>{ACTIVITY_LINK_TEXT}</th>
                            <th role={TEXTBOX} style={{width: 120, minWidth: 0,}}>{ACTION_TEXT}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {JSON.parse(JSON.stringify(data)).splice(0, 3).map((poll, index) => {
                            let pollStatus = getPollStatus(poll);
                            let badgeClass = pollStatus === SHARED_ENTIRELY ? styles.releaseEntirely : styles.releaseSingle;
                            let pollCode = removePrefixNew(poll.sk);

                            return (
                                <tr key={index} role={"row"} style={{cursor: "pointer"}}
                                    onClick={() => viewResult(poll)}>
                                    <td className={styles.omitableText}
                                        style={{textAlign: "left"}}>{poll.pollTitle}</td>
                                    <td >{pollCode}</td>
                                    <td >
                                        <div style={{display: "flex"}}>
                                            <span className={`${styles.badge} ${badgeClass}`} style={{width: 180}}>
                                               {pollStatus}
                                            </span>
                                        </div>
                                    </td>
                                    <td role={TEXTBOX}>
                                        <YuJaTooltip
                                            disabled={copied !== pollCode}
                                            text={COPIED_TEXT}
                                            placement={"bottom"}
                                            tooltipStyle={{maxWidth: 240}}
                                        >
                                            <CopyToClipboard
                                                text={`${shortName}.${config.host_url}/qr/${pollCode}`}
                                                onCopy={() => setCopied(pollCode)}
                                            >
                                                <div
                                                    style={{cursor: "pointer", width: "fit-content"}}
                                                    role={TEXTBOX}
                                                    aria-label={"Copy Join Activity Link"}
                                                    tabIndex={0}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <span style={{textDecoration: "underline"}}>{COPY_LINK_TEXT}</span>
                                                    <Copy
                                                        title={"copy join poll link"}
                                                        style={{
                                                            marginLeft: "5px",
                                                            maxWidth: "20px",
                                                            maxHeight: "20px",
                                                        }}
                                                    />
                                                </div>
                                            </CopyToClipboard>
                                        </YuJaTooltip>

                                    </td>
                                    <td>
                                        <div style={{display: "flex"}}>
                                        <span
                                            tabIndex={0}
                                            className={styles.gradientButton}
                                            role={TEXTBOX}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                viewResult(poll);
                                            }}
                                        >
                                            {VIEW_ACTIVITIES_TEXT}
                                        </span>
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                        </tbody>
                    </Table>
                </div>


                {/*<div className={styles.modifiedPollContainer}>*/}
                {/*    {JSON.parse(JSON.stringify(data)).splice(0, 3).map((poll, index) => (*/}
                {/*        <div key={index}*/}
                {/*             className={styles.modifiedPollUnit}*/}
                {/*             style={{*/}
                {/*                 display: "flex",*/}
                {/*                 alignItems: "center",*/}
                {/*                 justifyContent: "space-between"*/}
                {/*             }}*/}
                {/*        >*/}
                {/*            <span style={{display: "flex", width: "55%"}}>*/}
                {/*                <span role={TEXTBOX} tabIndex={0}*/}
                {/*                      className={styles.omitableText}>{poll.pollTitle}</span>*/}
                {/*                <CopyToClipboard*/}
                {/*                    text={`${shortName}.${config.host_url}/qr/${removePrefixNew(poll.index5Sk)}`}>*/}
                {/*                    <div onClick={() => notifySuccess(COPY_URL_SUCCESS)} role={TEXTBOX}*/}
                {/*                         aria-label={"Copy Join Poll Link"} tabIndex={0}>*/}
                {/*                        <Copy*/}
                {/*                            title={"copy join poll link"}*/}
                {/*                            style={{*/}
                {/*                                marginLeft: "5px",*/}
                {/*                                maxWidth: "20px",*/}
                {/*                                maxHeight: "20px",*/}
                {/*                                cursor: "pointer"*/}
                {/*                            }}*/}
                {/*                        />*/}
                {/*                    </div>*/}
                {/*            </CopyToClipboard>*/}
                {/*            </span>*/}
                {/*            /!* <span*/}
                {/*                tabIndex={0}*/}
                {/*                aria-label={"View results summary for poll " + poll.pollTitle}*/}
                {/*                role={BUTTON}*/}
                {/*                title={"go to poll page"}*/}
                {/*                style={{width: "45%", marginLeft: "10px", textAlign: "end", cursor: "pointer"}}*/}
                {/*                className={`${styles.gradientText} ${styles.linkText}`}*/}
                {/*                onClick={() => viewResult(poll)}*/}
                {/*            >*/}
                {/*                View Result Summary*/}
                {/*            </span> *!/*/}
                {/*            <GradientButton*/}
                {/*                role={TEXTBOX}*/}
                {/*                label={VIEW_RESULTS + poll.pollTitle}*/}
                {/*                style={{marginLeft: "15px"}}*/}
                {/*                onClick={() => viewResult(poll)}*/}
                {/*            >*/}
                {/*                {VIEW_RESULTS_TEXT}*/}
                {/*            </GradientButton>*/}
                {/*        </div>*/}
                {/*    ))}*/}
                {/*</div>*/}

                {/* </Spin> */}
            </div>

        </div>
    );
}